import type { WorkArrangements } from '@talentmesh/utils';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { RHFAutocompleteLocation } from '@/Components/AutocompleteLocation/RHFAutocompleteLocation';
import { JobDetailsFieldTypes } from '../../JobDetailsStepUtils';
import JobLocationLabel from './JobLocationLabel';
import UIStrings from '@/Utils/UIStrings';

const JobLocation = () => {
    const workArrangement: WorkArrangements = useWatch({ name: JobDetailsFieldTypes.WorkArrangement });

    if (
        (window as any).google === undefined ||
        (window as any).google.maps === undefined ||
        (window as any).google.maps.places === undefined
    ) {
        return null;
    }

    const isRemote = workArrangement === 'Remote';

    return (
        <RHFAutocompleteLocation
            name="jobLocation"
            placeholder={isRemote ? UIStrings.TypeCountry : UIStrings.TypeCity}
            locationType={isRemote ? 'regions' : 'cities'}
            label={<JobLocationLabel />}
        />
    );
};

export default JobLocation;
